export default () => {
  $(document).on("click", ".block-stucture__item a", function () {
    const $html = $(this).html();

    $("#structure").html($html);
  });
};
